<template>
  <div class="w-full h-full px-5 pt-5">
    <loader v-if="Object.keys(summary).length === 0" size="xxs" :loader-image="false" />
    <div v-else class="flex flex-col">
      <div class="flex justify-start items-center gap-6 mt-4 mb-8">
        <div @click="$router.back()" 
            class="text-darkPurple cursor-pointer font-semibold text-base flex gap-2 items-center"
        >
            <div ><icon icon-name="back_arrow" size="s" class="w-8 h-8 rounded text-romanSilver"/></div> 
            Back
        </div>
        <div class="h-5 border border-borderGrey"></div>
        <h1 class="text-xl text-left font-extrabold">
            Documents
        </h1>
        <breadcrumb :items="breadcrumbs" />
      </div>


      <div class="w-full">
        <div class="w-full flex flex-row justify-between gap-3 mt-6 mb-3">
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                  <icon icon-name="icon-folder" size="xsm" />
              </div>
              <div>
                  <p class="text-base font-semibold text-romanSilver">Folder Name</p>
                  <p class="text-sm text-jet font-semibold">{{ summary.folderName ? summary.folderName : "-"}}</p>
              </div>
          </Card>   
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                  <icon icon-name="solar-user-icon" size="xsm" />
              </div>
              <div>
                  <p class="text-base font-semibold text-romanSilver">Group</p>
                  <p class="text-sm text-jet font-semibold">{{ summary.groupName ? summary.groupName : "-"  }}</p>
              </div>
          </Card>  
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                  <icon icon-name="user" size="xsm" />
              </div>
              <div>
                  <p class="text-base font-semibold text-romanSilver">Owner</p>
                  <p class="text-sm text-jet font-semibold">
                    {{ summary.owner ? summary.owner.fname + ' ' + summary.owner.lname : '-'  }}
                  </p>
              </div>
          </Card>  
        </div> 

        <div class="w-full flex flex-row justify-between gap-3 mb-6">
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                <img
                  src="@/assets/images/files-multi.png"
                  style="width: 24px; height: 24px"
                />
              </div>
              <div>
                  <p class="text-base font-semibold text-romanSilver">Files</p>
                  <p class="text-sm text-jet font-semibold uppercase">
                    {{ summary.totalNumberOfFiles ? summary.totalNumberOfFiles : "-" }}
                  </p>
              </div>
          </Card>   
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                <img
                  src="@/assets/images/home-storage.png"
                  style="width: 24px; height: 24px"
                />
              </div>
              <div>
                <p class="text-base font-semibold text-romanSilver">Storage</p>
                <p class="text-sm text-jet font-semibold uppercase">
                  {{ summary.folderSize ? kbToSize(summary.folderSize) : "-" }}
                  of
                  {{ summary.totalSize ? kbToSize(summary.totalSize) : "-" }}
                </p>
              </div>
          </Card>  
          <Card class="card flex flex-row justify-start items-center gap-3 p-3">
              <div>
                <img
                  src="@/assets/images/schedule-school-date-time.png"
                  style="width: 24px; height: 24px"
                />
              </div>
              <div>
                  <p class="text-base font-semibold text-romanSilver">Last Modified</p>
                  <p class="text-sm text-jet font-semibold uppercase">
                    {{ summary.lastModified ? $DATEFORMAT(new Date(summary.lastModified), "MMMM dd, yyyy")  : "-" }}
                  </p>
              </div>
          </Card>  
        </div>
      </div>


      <div class="line"/>
      
      <div class="w-full flex justify-end items-end my-4">
        <Button
          @click="isUploadFile = true"
          :class="'text-white bg-dynamicBackBtn w-36 h-11 rounded-xl flex items-center justify-between'"
        >
          Upload File
        </Button>
      </div>
      
      <div class="line"/>

      <div class="h-full">
        <div>
          <div>
            <Card class="p-5">
              <template v-slot:footer>
                <card-footer
                    @reload="reload()"
                    @sortType="handleSort($event)"
                    @option="handleOptionSelect($event)"
                    @searchResult="handleSearch($event)"
                    @actionModal="viewFilterTable($event)"
                    search-placeholder="Search"
                    :show-sort-filter="false"
                />
              </template>
            </Card>

            <sTable
              :headers="filesHeader"
              :items="files"
              style="width: 100%"
              :loading="isloading"
              aria-label="employee table"
              class="w-full"
              id="printMe"
              :pagination-list="allFilesMeta"
              @page="handlePage($event)"
              @itemsPerPage="handleItemsPerPage($event)"
              page-sync
              :has-number="false"
              :has-checkbox="true"
              v-if="allFiles.length > 0"
              >
              <template v-slot:item="{ item }">
                <template v-if="item.name">
                  <div
                    class="flex flex-row items-center"
                  >
                    <template>
                      <div>
                        <icon icon-name="doc" size="s" class="w-8 h-8 rounded" v-if="item.data.fileType.includes('doc')"/>
                        <icon icon-name="xlsx" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('xlsx')"/>
                        <icon icon-name="xlsx" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('vnd.ms-excel')"/>
                        <icon icon-name="csv" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('csv')"/>
                        <icon icon-name="png" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('png')"/>
                        <icon icon-name="ppt" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('ppt')"/>
                        <icon icon-name="pdf" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('pdf')"/>
                        <icon icon-name="jpg" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('jpg')"/>
                        <icon icon-name="jpg" size="s" class="w-8 h-8 rounded" v-else-if="item.data.fileType.includes('jpeg')"/>
                      </div>
                    </template>
                    <p class="w-40 h-auto break-all mr-5 font-bold ml-2 text-sm flex flex-col justify-Start items-start">
                        {{ item.data.name }}
                    </p>
                  </div>
                </template>
                <template v-else-if="item.fileSize">
                  <div class="text-sm flex flex-col justify-between">
                    <span class="font-bold text-darkPurple">
                      {{ kbToSize(item.data.fileSize)  }}
                    </span>
                  </div>
                </template>
                <template v-else-if="item.createdBy">
                  <div
                    class="flex flex-row items-center"
                  >
                    <template>
                      <div>
                        <img v-if="item.data.createdBy.photo" :src="item.data.createdBy.photo" alt="profile pic" class="w-8 h-8 rounded" />
                        <div v-else class="w-8 h-8 rounded text-blueCrayola border text-center font-semibold pt-2">
                          {{ $getInitials(`${item.data.createdBy.fname} ${item.data.createdBy.lname}`) }}
                        </div>
                      </div>
                    </template>
                    <div class="ml-2 text-sm flex flex-col justify-between">
                      <span class="font-bold cursor-pointer text-jet">
                        {{ item.data.createdBy ? item.data.createdBy.fname + ' ' + item.data.createdBy.lname : '-' }}
                      </span>
                      <span class="font-extrabold cursor-pointer text-romanSilver uppercase text-xs">
                        {{ item.data.createdBy.orgFunction ? item.data.createdBy.orgFunction.name : '-' }}
                      </span>
                    </div>
                  </div>
                </template>
                <div v-else-if="item.filePermissions" class="flex text-left">
                  <div class="flex items-center gap-1" v-if="item.data.filePermissions.length > 0">
                    <div v-for="(user, index) in getUserPhotos(item.data.filePermissions)" :key="index">
                      <img :src="user.photo" alt="" v-if="user.photo" class="w-8 h-8">
                      <div v-else class="w-8 h-8 rounded text-blueCrayola border text-center font-semibold pt-2">
                        {{ $getInitials(user.name) }} 
                      </div>
                    </div>
                    <span v-if="item.data.filePermissions[0].permissionUsers && item.data.filePermissions[0].permissionUsers.length >= 3" class="text-blueCrayola font-semibold">
                      +{{item.data.filePermissions[0].permissionUsers.length - 2}}
                    </span>
                  </div>
                  <span v-else>-</span>
                </div>
                <p v-else-if="item.createdAt" class="text-left">
                  <span v-if="item.data.createdAt">
                    {{ $DATEFORMAT(new Date(item.data.createdAt), "MMMM dd, yyyy") }}
                  </span>
                  <span v-else>-</span>
                </p>
                <p v-else-if="item.updatedAt" class="text-left">
                  <span v-if="item.data.updatedAt">
                    {{ $DATEFORMAT(new Date(item.data.updatedAt), "MMMM dd, yyyy") }}
                  </span>
                  <span v-else>-</span>
                </p>
                <span v-else-if="item.fileId">
                <Menu left top="-150" margin="24" class="my-2 p-0">
                  <template v-slot:title>
                    <icon icon-name="more_icon" size="xs" />
                  </template>
                    <div class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2">
                      <div class="w-full" @click="actions('view-file', item.data)">
                          <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                              <Icon icon-name="icon-eye" class-name="text-blueCrayola" size="xs" />
                              <p class="font-normal text-sm text-darkPurple">View File</p>
                          </div>
                      </div>
                      <div class="w-full" @click="actions('permissions', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-lock-green" class-name="text-mediumSeaGreen" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Permissions</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('rename', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="edit" class-name="text-blueCrayola" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Rename</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('move-file-to-folder', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-doc" class-name="text-carrotOrange" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Move to Folder</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('download', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="download" class-name="text-flame" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Download</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('info', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-information" class-name="text-flame" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Information</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('audit-info', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="icon-audit" class-name="text-desire" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Audit</p>
                        </div>
                      </div>
                      <div class="w-full" @click="actions('delete', item.data)">
                        <div class="w-full flex justify-start items-center gap-2 cursor-pointer">
                          <Icon icon-name="delete" class-name="text-desire" size="xs" />
                          <p class="font-normal text-sm text-darkPurple">Delete File</p>
                        </div>
                      </div>
                    </div>
                  </Menu>
                </span>
                </template>
            </sTable>
            <div class="w-full h-64 flex flex-col justify-center items-center gap-5" v-if="allFiles.length === 0">
              <img class="wfull" :src="require('@/assets/images/emptyFolders.svg')" alt="not_found">
              <p class="">There are no files in your account yet.</p>
            </div>
          </div>
        </div>
      </div>
    </div> 

    <ViewFile v-if="openViewFile" 
      @close="openViewFile = false" 
      :item="selectedItem" 
    /> 
    <DownloadFile v-if="openDownloadFile" 
      @close="openDownloadFile = false" 
      :item="selectedItem" 
    />
    <UploadFile v-if="isUploadFile"
      @close="isUploadFile = false"
      :folders="folders"
      :setPermission="false"
      @refresh="refresh($event)"
    />

    <!-- <FilterTable
      v-if="filterTable"
      :filter-data="filterData"
      @close="closeFilter($event)"
      @getParams="searchFilter($event)"
    />  -->
    <Delete
      v-if="openDelete"
      @close="close($event)"
      @refresh="refresh($event)"
      current-tab="files"
      :id="selectedItem.fileId"
    />
    <Information
      v-if="openInfo"
      @close="close($event)"
      current-tab="files"
      :item="selectedItem"
      @open-permisssions="openInfo = false, openPermissions = true"
    />
    <AuditInfo
      v-if="openAudit"
      @close="close($event)"
      current-tab="files"
      :item="selectedItem"
      @open-permisssions="openAudit = false, openPermissions = true"
    />
    <PermissionsSettings
      v-if="openPermissions"
      @close="close($event)"
      current-tab="files"
      :item="selectedItem"
      :folders="allFiles"
      :files="allFiles"
      @refresh="refresh($event)"
    />
    <Rename
      v-if="openRename"
      @close="close($event)"
      current-tab="files"
      :item="selectedItem"
      :groups="allGroups"
      @refresh="refresh($event)"
    />
    <MoveFileToFolder
      v-if="openMoveFileToFolder"
      @close="close($event)"
      :current-tab="files"
      :item="selectedItem"
      :folders="allFolders"
      @refresh="refresh($event)"
    />
  </div>     
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import STable from "@scelloo/cloudenly-ui/src/components/table";
  
  export default {
    name: "ViewFolder",
    components: {
      Breadcrumb,
      STable,
      Card: () => import('@/components/Card'),
      CardFooter: () => import("@/components/CardFooter"),
      Menu: () => import("@/components/Menu"),
      Button: () => import("@/components/Button"),
      FilterTable: () => import ("@/components/FilterTable"),
      ViewFile: () => import("@/components/documents/ViewFile"),
      Delete: () => import ('@/components/documents/Delete'),
      Information: () => import ('@/components/documents/Information'),
      AuditInfo: () => import ('@/components/documents/AuditInfo'),
      Rename: () => import ('@/components/documents/Rename'),
      MoveFileToFolder: () => import ('@/components/documents/MoveFileToFolder'),
      PermissionsSettings: () => import ('@/components/documents/PermissionsSettings'),
      UploadFile: () => import ('@/components/documents/UploadFile'),
      DownloadFile: () => import("@/components/documents/DownloadFile"),
    },
    data() {
      return {
        isloading: false,
        filterTable: false,
        folderSummary: {},
        allFiles: [],
        allFolders: [],
        allGroups: [],
        allFilesMeta: {},
        sortType: null,
        itemsPerPage: null,
        numberOfPage: null,
        searchWord: null,

        isUploadFile: false,
        openDownloadFile: false,  
        openViewFile: false,   
        openDelete: false,
        openInfo: false,
        openAudit: false,
        openRegroup: false,
        openRename: false,
        openMoveFileToFolder: false,
        openPermissions: false,
        selectedItem: null,
        allFolderResponse:[]
      };
    },
    computed: {
      breadcrumbs() {
        return [
          {
            disabled: false,
            text: "Documents",
            href: "OrganisationCompanyDocuments",
            id: "DocumentMgt",
          },
          {
            disabled: false,
            text: "Employee Documents",
            href: "EmployeeDocuments",
            id: "EmpDocuments",
          },
          {
            disabled: false,
            text: "View Folder",
            href: "ViewFolder",
            id: "ViewFolder",
          },
        ];
      },
      filesHeader() {
        return [
          { title: "File name", value: "name" },
          { title: "File Size", value: "fileSize" },
          { title: "Owner", value: "createdBy" },
          { title: "Access", value: "filePermissions" },
          { title: "Date Uploaded", value: "createdAt" },
          { title: "Last Modified", value: "updatedAt" },
          { title: "", value: "fileId", image: true }
        ];
      },
      files(){ 
        return this.allFiles;
      },
      folders() {
        return this.allFolders;
      },
      summary(){ 
        return this.folderSummary;
      }
    },
    methods: {
      actions(type, item) {
        this.selectedItem = item;
        switch (type) {
            case 'download':
                this.openDownloadFile = true;
            break;
            case 'view-file':
                this.openViewFile = true;
            break;
            case 'delete':
              this.openDelete = true;
              break;
            case 'info':
              this.openInfo = true;
              break;
            case 'audit-info':
              this.openAudit = true;
              break;
            case 'rename':
              this.openRename = true;
              break;
            case 'move-file-to-folder':
              this.openMoveFileToFolder = true;
              break;
            case 'permissions':
              this.openPermissions = true;
              break;

            default:
            break;
        }
      },
      close(type) {
        switch (type) {
          case 'delete':
            this.openDelete = false;
            break;
          case 'info':
            this.openInfo = false;
            break;
          case 'audit-info':
            this.openAudit = false;
            break;
          case 'rename':
            this.openRename = false;
            break;
          case 'move-file-to-folder':
            this.openMoveFileToFolder = false;
            break;
          case 'permissions':
            this.openPermissions = false;
            break;

          default:
            break;
        }
      },
      // viewFilterTable(value) {
      //   if (value) {
      //     this.filterTable = true;
      //   }
      // },
      queryUpdate() {
        const search = this.searchWord ? `search=${this.searchWord}` : `search=${''}`;
        this.viewFolder(search);
        
        // this.filterTable = false;
      },
      handleSort(sortType) {
          this.sortType = sortType;
          this.queryUpdate();
      },
      handlePage(pageNumber) {
          this.numberOfPage = pageNumber;
          this.queryUpdate();
      },
      handleSearch(searchWord) {
          if (searchWord) {
              this.searchWord = searchWord;
              this.queryUpdate();
          } else {
              this.searchWord = null;
              this.queryUpdate();
          }
      },
      handleItemsPerPage(itemNo) {
          this.itemsPerPage = itemNo;
          this.queryUpdate();
      },
      // searchFilter(params) {
      //   if(this.currentTab.toLowerCase().includes('folders')){
      //     this.getAllFolders(params);
      //   }else{
      //     this.getAllFiles(params);
      //   }
      //   this.filterTable = false;
      // },
      // closeFilter(val) {
      //   if (val) {
      //     this.filterTable = false;
      //   }
      // },
      async getAllFolders(params=''){
        if(this.$route.query.type === "organization"){
          const { data } = await this.$_getAllFolders(this.$orgId,params);
          this.allFolderResponse = data
        }else{
          const { data } = await this.$_getAllEssEmployeesFolders(this.$orgId, this.$AuthUser.id, params);
          this.allFolderResponse = data
        }

        this.allFolders = this.allFolderResponse.folders === 0 ? [] : this.allFolderResponse.folders;
        const folder = this.allFolders.filter(folder => folder.folderId === this.$route.query.folderId)
        this.folderSummary = {
          folderName: folder[0].name,
          groupName: folder[0].group?.name,
          owner: folder[0].createdBy,
          totalNumberOfFiles: folder[0].numberOfFiles,
          folderSize: folder[0].folderSize,
          totalSize: folder[0].maxStorage,
          lastModified: folder[0].updatedAt,
        };
      },
      async getAllGroups() {
        const { data } = await this.$_getAllGroups(
          this.$orgId
        );
        this.allGroups = data.groups === 0 ? [] : data.groups;
        // this.filterArray[3] = { header: "Groups", value: "groupId", optionsBox: data.groups.map(item=>( {id:item.id, name:item.name})) };
      },
      async refresh() {
        await this.viewFolder();
        await this.getAllFolders();
        await this.getAllGroups();
      },
      async viewFolder(params=''){
        this.isloading = true;
        try{
          const { data } = await this.$_getAFolderFiles(this.$orgId, this.$AuthUser.id, this.$route.query.type, this.$route.query.folderId, params);
          this.allFiles = data.files === 0 ? [] : data.files;
          this.allFilesMeta = data.meta ? data.meta : {};
          this.isloading = false;
        }catch (error) {
          this.isloading = false;
        }
      },
      getUserPhotos(data) {
        const userPhotos = [];
        if(data[0].permissionUsers.length >= 3){
          data[0].permissionUsers.slice(0,2).forEach(permissionUser => {
            userPhotos.push({
              name:`${permissionUser.accessUser?.fname  } ${  permissionUser.accessUser?.lname}`,
              photo:permissionUser.accessUser.photo ? permissionUser.accessUser.photo : null,
            });
          });
        }else{
          data[0].permissionUsers.forEach(permissionUser => {
            userPhotos.push({
              name:`${permissionUser.accessUser?.fname  } ${  permissionUser.accessUser?.lname}`,
              photo:permissionUser.accessUser.photo ? permissionUser.accessUser.photo : null,
            });
          });
        }
        return userPhotos;
      },
      kbToSize(kb) {   
        const sizes = ['KB', 'MB', 'GB', 'TB', 'PB'];
        if (kb === 0) return '0 KB';
        if (kb < 1) return `${(kb * 1024).toFixed(1)} KB`; 
            const i = parseInt(Math.floor(Math.log(kb) / Math.log(1024)), 10);
            const sizeIndex = Math.min(i, sizes.length - 1);
        if (sizeIndex === 0) return `${kb.toFixed(1)} ${sizes[sizeIndex]}`;
        return `${(kb / (1024 ** sizeIndex)).toFixed(1)} ${sizes[sizeIndex]}`;
      }
    },
    async mounted() {
      await this.viewFolder();
      await this.getAllFolders();
      await this.getAllGroups();
    }
  };
</script>

<style scoped>
.card{
    width: calc(100% / 3) !important;
    height: 68px !important;
    border: 1px solid #00000029 !important;
    border-radius: 8px !important;
}
.line{
  border: 1px solid #00000029;
  width: 100%;
  height: 0;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 0;
}
.text-10{
  font-size: 10px !important;
}
</style>  